import React from 'react'

export const getWordsCount = str => str.trim().split(/\s+/).length

export const getCharsCount = str => str.replace(/\s+/g, '').length

export const getEmojisCount = str => {
  let count = 0
  str.replace(/[\u{1F300}-\u{1F6FF}]/gu, () => count++)
  return count
}

export const formatUsernames = (allUsers, userIds, isMention) => {
  if (!userIds) {
    return ''
  }

  const usernames = userIds
    .map(userId => {
      const user = allUsers.get(userId)
      return user ? user.get('username') : 'someone'
    })
    .toArray()

  return usernames.reduce(
    (memo, username, index) =>
      memo.concat(
        <span
          key={index}
          className="shade-05 font-weight-bold font-size-normal padding-horizontal-smaller"
        >
          @{username}
        </span>
      ),
    []
  )
}
